var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommonAgreement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-1206.000000, -1574.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Common/Agreement",
    transform: "translate(1206.000000, 1574.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.626,8 C3.176,8 5.471,9.073 7.101,10.787 L7.101,10.787 L7.107,10.78 L13,16.993 L19,16.993 L24.894,10.781 C26.528,9.073 28.824,8 31.374,8 L31.374,8 L32,8 L32,25.997 L22.432,25.997 L22.432,18.189 L20.59,20.04 L11.401,20.031 L11.401,20.001 L9.568,18.167 L9.568,32 L0,32 L0,8 Z M24.4287,0 C26.3617,0 27.9287,1.567 27.9287,3.5 C27.9287,5.433 26.3617,7 24.4287,7 C22.4947,7 20.9287,5.433 20.9287,3.5 C20.9287,1.567 22.4947,0 24.4287,0 Z M7.4609,0 C9.3939,0 10.9609,1.567 10.9609,3.5 C10.9609,5.433 9.3939,7 7.4609,7 C5.5279,7 3.9609,5.433 3.9609,3.5 C3.9609,1.567 5.5279,0 7.4609,0 Z",
    id: 197
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonAgreement);
export default __webpack_public_path__ + "static/media/common-agreement.9b5d8508.svg";
export { ForwardRef as ReactComponent };